import logger, { VERBOSE } from "./logger";
import type { UnsubsByPath } from "./types";
import { type Unsubscribe } from "../../dependencies/firebase";

export default function addUnsub(
  unsubsByPath: UnsubsByPath,
  path: string,
  unsub: Unsubscribe,
) {
  if (VERBOSE) {
    logger.log(`Add unsub "${path}"`);
  }

  unsubsByPath[path] = unsub;
}
